import { createSlice } from '@reduxjs/toolkit';
import { resetAllReduxStates } from './resetAllReduxStatesAction';

const initialState = {
  columnVisibility: {}, // { tableId: [visibleColumnIds, ...] }
};

export const columnVisibilitySlice = createSlice({
  name: 'columnVisibility',
  initialState,
  reducers: {
    setColumnVisibility: (state, action) => {
      const { tableId, columnId, reset } = action.payload;
      if (reset) {
        delete state.columnVisibility[tableId]; // Reset state to default
      } else {
        if (!state.columnVisibility[tableId]) {
          state.columnVisibility[tableId] = [];
        }

        const current = state.columnVisibility[tableId];
        if (current.includes(columnId)) {
          // Hide column
          state.columnVisibility[tableId] = current.filter((id) => id !== columnId);
        } else {
          // Show column
          state.columnVisibility[tableId] = [...current, columnId];
        }
      }
    },

    setAllVisibleColumns: (state, action) => {
      const { tableId, columnIds } = action.payload;
      state.columnVisibility[tableId] = columnIds;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetAllReduxStates, () => initialState);
  },
});

export const {
  setColumnVisibility,
  setAllVisibleColumns,
} = columnVisibilitySlice.actions;

export default columnVisibilitySlice.reducer;
